export const API_ENDPOINTS = {
    LOGIN: process.env.NEXT_PUBLIC_ENDPOINT_LOGIN || "/auth/login",
    LOGOUT: process.env.NEXT_PUBLIC_ENDPOINT_LOGOUT || "/auth/logout",
    REFRESH: process.env.NEXT_PUBLIC_ENDPOINT_REFRESH || "/auth/refresh",
    VERIFY_2FA: process.env.NEXT_PUBLIC_ENDPOINT_VERIFY_2FA || "/auth/verify-2fa",
    REGISTER: process.env.NEXT_PUBLIC_ENDPOINT_REGISTER || "/auth/register",
    VERIFY_EMAIL: "/auth/verify-email",
    RESEND_VERIFICATION: "/auth/resend-verification",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
    ADMIN_SETUP: "/auth/admin-setup",
    FILE_STREAM: "/files/stream",
    FILE_DOWNLOAD_URL: "/files/download-url",
    USER_PROFILE: process.env.NEXT_PUBLIC_ENDPOINT_USER_PROFILE || "/auth/user/profile",
    UPDATE_PROFILE: process.env.NEXT_PUBLIC_ENDPOINT_UPDATE_PROFILE || "/auth/user/profile",
    CHANGE_PASSWORD: process.env.NEXT_PUBLIC_ENDPOINT_CHANGE_PASSWORD || "/auth/change-password",
    ENABLE_2FA: process.env.NEXT_PUBLIC_ENDPOINT_ENABLE_2FA || "/auth/enable-2fa",
    DISABLE_2FA: process.env.NEXT_PUBLIC_ENDPOINT_DISABLE_2FA || "/auth/disable-2fa",
    GET_SESSIONS: process.env.NEXT_PUBLIC_ENDPOINT_GET_SESSIONS || "/auth/sessions",
    TERMINATE_ALL_SESSIONS: "/auth/sessions/terminate-all",
    LOGOUT_SESSION: (sessionId: string) => `/auth/sessions/${sessionId}/logout`,
    SCHEDULE_ACCOUNT_DELETION: "/auth/user/account/schedule-deletion",
    DELETE_ACCOUNT_IMMEDIATE: "/auth/user/account/delete-immediate",
    USER_SETTINGS: process.env.NEXT_PUBLIC_ENDPOINT_USER_SETTINGS || "/user/settings",
    UPDATE_SETTINGS: process.env.NEXT_PUBLIC_ENDPOINT_UPDATE_SETTINGS || "/user/settings",
    UPDATE_PREFERENCES: process.env.NEXT_PUBLIC_ENDPOINT_UPDATE_PREFERENCES || "/user/preferences",
    EXCHANGE_RATES_LATEST: process.env.NEXT_PUBLIC_ENDPOINT_EXCHANGE_RATES_LATEST || "/exchange-rates/latest",
    
    PROFILE:process.env.NEXT_PUBLIC_ENDPOINT_PROFILE || "/company/profile",
    PROFILE_ADDRESSES:process.env.NEXT_PUBLIC_ENDPOINT_PROFILE_ADDRESSES || "/company/addresses",
    PROFILE_DOCUMENTS:process.env.NEXT_PUBLIC_ENDPOINT_PROFILE_DOCUMENTS || "/company/documents",
    FLEET_DRIVERS: "/company/fleet/drivers",
    FLEET_DRIVER: (id: string | number) => `/company/fleet/drivers/${id}`,
    FLEET_VEHICLES: "/company/fleet/vehicles",
    FLEET_VEHICLE: (id: string | number) => `/company/fleet/vehicles/${id}`,
    COMPANY_USER_ACCESS: process.env.NEXT_PUBLIC_ENDPOINT_COMPANY_USER_ACCESS || "/company/users/access",
    COMPANY_USER_ACCESS_POLICY: process.env.NEXT_PUBLIC_ENDPOINT_COMPANY_USER_ACCESS_POLICY || "/company/users/access/policy",
    COMPANY_USER_ALLOWLIST: process.env.NEXT_PUBLIC_ENDPOINT_COMPANY_USER_ALLOWLIST || "/company/users/access/allowlist",
    COMPANY_USER_ALLOWLIST_ITEM: (id: string | number) => `/company/users/access/allowlist/${id}`,
    COMPANY_USER_ALLOWLIST_RESEND: (id: string | number) => `/company/users/access/allowlist/${id}/resend-invitation`,
    COMPANY_PUBLIC_PROFILE: (companyId: string | number) => `/company/${companyId}/public-profile`,

    RFQ_CREATE:process.env.NEXT_PUBLIC_ENDPOINT_RFQ_CREATE || "/rfq",
    RFQ_TEMPLATES: process.env.NEXT_PUBLIC_ENDPOINT_RFQ_TEMPLATES || "/rfq/templates",
    RFQ_TEMPLATE_DETAIL: (templateId: string | number) => `/rfq/templates/${templateId}`,

    // Admin endpoints
    ADMIN_OPERATORS: "/admin/operators",
    ADMIN_OPERATORS_CREATE: "/admin/operators",
    ADMIN_OPERATORS_DETAIL: (id: string) => `/admin/operators/${id}`,
    ADMIN_OPERATORS_UPDATE: (id: string) => `/admin/operators/${id}`,
    ADMIN_OPERATORS_DELETE: (id: string) => `/admin/operators/${id}`,
    ADMIN_OPERATORS_UPDATE_STATUS: (id: string) => `/admin/operators/${id}/status`,
    ADMIN_OPERATORS_RESET_PASSWORD: (id: string) => `/admin/operators/${id}/reset-password`,
    ADMIN_USERS: "/admin/users",
    ADMIN_USERS_DETAIL: (id: string) => `/admin/users/${id}`,
    ADMIN_USERS_DOCUMENTS: (id: string) => `/admin/users/${id}/documents`,
    ADMIN_USERS_PAYMENT_HISTORY: (id: string) => `/admin/users/${id}/payment-history`,
    ADMIN_USERS_UPDATE_STATUS: (id: string) => `/admin/users/${id}/status`,
    ADMIN_USERS_RESET_PASSWORD: (id: string) => `/admin/users/${id}/reset-password`,
    ADMIN_USERS_UPDATE_ROLE: (id: string) => `/admin/users/${id}/role`,
    ADMIN_USERS_VERIFY: (id: string) => `/admin/users/${id}/verify`,
    ADMIN_USERS_DELETE: (id: string) => `/admin/users/${id}`,
    ADMIN_DASHBOARD_STATS: "/admin/dashboard/stats",
    ADMIN_DASHBOARD_ACTIVITY: "/admin/dashboard/activity",

    // Operator RFQ endpoints
    OPERATOR_RFQ_AVAILABLE: "/operator/rfq",
    OPERATOR_RFQ_ASSIGN: (rfqId: string) => `/operator/rfq/${rfqId}/assign`,
    OPERATOR_RFQ_ASSIGNED: "/operator/rfq/assigned",
    OPERATOR_RFQ_DETAILS: (rfqId: string) => `/operator/rfq/${rfqId}`,
    OPERATOR_RFQ_VALIDATE: (rfqId: string) => `/operator/rfq/${rfqId}/validate`,
    OPERATOR_RFQ_REASSIGN: (rfqId: string) => `/operator/rfq/${rfqId}/reassign`,
    OPERATOR_WORKLOAD: "/operator/workload",
    OPERATOR_USERS: "/operator/users",
    OPERATOR_USERS_DETAIL: (id: string | number) => `/operator/users/${id}`,
    OPERATOR_USERS_STATUS: (id: string | number) => `/operator/users/${id}/status`,
    OPERATOR_USERS_VERIFY: (id: string | number) => `/operator/users/${id}/verify`,
    OPERATOR_USERS_DOCUMENTS: (id: string | number) => `/operator/users/${id}/documents`,
    OPERATOR_USERS_DOCUMENT_STATUS: (id: string | number, documentId: string | number) => `/operator/users/${id}/documents/${documentId}/status`,
    OPERATOR_USERS_DOCUMENTS_OVERVIEW: (id: string | number) => `/operator/users/${id}/documents/overview`,
    OPERATOR_USERS_PAYMENT_HISTORY: (id: string | number) => `/operator/users/${id}/payment-history`,
    SUPPORT_TICKETS: "/support/tickets",
    SUPPORT_TICKET_DETAIL: (ticketId: string | number) => `/support/tickets/${ticketId}`,
    SUPPORT_TICKET_REPLY: (ticketId: string | number) => `/support/tickets/${ticketId}/reply`,
    SUPPORT_TICKETS_STATS: "/support/tickets/stats",
    ADMIN_SUPPORT_TICKETS: "/admin/support/tickets",
    ADMIN_SUPPORT_TICKET_DETAIL: (ticketId: string | number) => `/admin/support/tickets/${ticketId}`,
    ADMIN_SUPPORT_TICKET_REPLY: (ticketId: string | number) => `/admin/support/tickets/${ticketId}/reply`,
    ADMIN_SUPPORT_TICKET_STATUS: (ticketId: string | number) => `/admin/support/tickets/${ticketId}/status`,
    ADMIN_SUPPORT_TICKETS_STATS: "/admin/support/tickets/stats",
    RFQ_HISTORY: (rfqId: string) => `/rfq/${rfqId}/history`,
    RFQ_VALIDATE: (rfqId: string) => `/rfq/${rfqId}/validate`,
    RFQ_REJECT: (rfqId: string) => `/rfq/${rfqId}/reject`,
    RFQ_REQUEST_CLARIFICATION: (rfqId: string) => `/rfq/${rfqId}/clarification`,
    RFQ_APPROVE_CLARIFICATIONS: (rfqId: string) => `/rfq/${rfqId}/approve-clarifications`,
    RFQ_ATTACHMENTS_UPLOAD: (rfqId: string) => `/rfq/${rfqId}/attachments`,
    RFQ_ATTACHMENT_DELETE: (rfqId: string | number, attachmentId: string | number) => `/rfq/${rfqId}/attachments/${attachmentId}`,
    RFQ_NOTES: (rfqId: string) => `/rfq/${rfqId}/notes`,
    RFQ_NOTES_UNREAD_COUNT: (rfqId: string | number) => `/rfq/${rfqId}/notes/unread-count`,
    RFQ_NOTES_READ_ALL: (rfqId: string | number) => `/rfq/${rfqId}/notes/read-all`,
    RFQ_NOTE_DELETE: (rfqId: string, noteId: string | number) => `/rfq/${rfqId}/notes/${noteId}`,
    OPERATOR_RFQ_OFFERS: (rfqId: string | number) => `/offers/rfq/${rfqId}`,
    OPERATOR_RFQ_PUBLISH_OFFERS: (rfqId: string | number) => `/offers/rfq/${rfqId}/publish`,
    OPERATOR_OFFER_TAKE: (offerId: string | number) => `/offers/${offerId}/take`,
    OPERATOR_OFFER_VALIDATE: (offerId: string | number) => `/offers/${offerId}/validate`,
    OPERATOR_OFFER_OBSERVATIONS: (offerId: string | number) => `/offers/${offerId}/observations`,
    OPERATOR_OFFER_REJECT: (offerId: string | number) => `/offers/${offerId}/reject`,
    OPERATOR_OFFER_CLARIFICATION: (offerId: string | number) => `/offers/${offerId}/clarification`,
    OPERATOR_OFFER_RENEGOTIATE: (offerId: string | number) => `/offers/${offerId}/renegotiate`,
    OPERATOR_ORDERS_MONITORING: "/orders/monitoring",
    BUYER_PUBLISHED_OFFERS: "/offers/buyer/published",
    BUYER_PUBLISHED_OFFERS_BY_RFQ: (rfqId: string | number) => `/offers/rfq/${rfqId}/published`,
    BUYER_ACCEPT_OFFER: (offerId: string | number) => `/offers/${offerId}/accept`,
    BUYER_REJECT_OFFER: (offerId: string | number) => `/offers/${offerId}/decline`,
    BUYER_FINALIZE_PARTIAL_SELECTION: (rfqId: string | number) => `/offers/rfq/${rfqId}/buyer/finalize-selection`,

    // Supplier Marketplace endpoints
    SUPPLIER_MARKETPLACE_RFQ_LIST: "/supplier/marketplace/rfq",
    SUPPLIER_MARKETPLACE_RFQ_DETAILS: (rfqId: string) => `/supplier/marketplace/rfq/${rfqId}`,
    SUPPLIER_MARKETPLACE_RFQ_DISTANCE: (rfqId: string) => `/supplier/marketplace/rfq/${rfqId}/distance`,
    SUPPLIER_MARKETPLACE_CREATE_OFFER: (rfqId: string) => `/supplier/marketplace/rfq/${rfqId}/offers`,
    SUPPLIER_OFFERS_CREATE: process.env.NEXT_PUBLIC_ENDPOINT_SUPPLIER_OFFERS_CREATE || "/offers",
    SUPPLIER_OFFERS_UPDATE: (offerId: string | number) =>
        `${process.env.NEXT_PUBLIC_ENDPOINT_SUPPLIER_OFFERS_UPDATE_BASE || "/offers"}/${offerId}`,
    SUPPLIER_OFFERS_DELETE: (offerId: string | number) =>
        `${process.env.NEXT_PUBLIC_ENDPOINT_SUPPLIER_OFFERS_UPDATE_BASE || "/offers"}/${offerId}`,
    SUPPLIER_OFFERS_SUBMIT: (offerId: string | number) =>
        `${process.env.NEXT_PUBLIC_ENDPOINT_SUPPLIER_OFFERS_UPDATE_BASE || "/offers"}/${offerId}/submit`,
    SUPPLIER_MY_OFFERS: `${process.env.NEXT_PUBLIC_ENDPOINT_SUPPLIER_OFFERS_UPDATE_BASE || "/offers"}/my-offers`,
    OFFER_HISTORY: (offerId: string | number) => `/offers/${offerId}/history`,
    OFFER_NOTES: (offerId: string | number) => `/offers/${offerId}/notes`,
    OFFER_NOTES_ATTACHMENTS: (offerId: string | number) => `/offers/${offerId}/notes/attachments`,
    OFFER_NOTES_UNREAD_COUNT: (offerId: string | number) => `/offers/${offerId}/notes/unread-count`,
    OFFER_NOTES_READ_ALL: (offerId: string | number) => `/offers/${offerId}/notes/read-all`,
    OFFER_NOTE_DELETE: (offerId: string | number, noteId: string | number) => `/offers/${offerId}/notes/${noteId}`,
    SUPPLIER_MARKETPLACE_MY_OFFER: (rfqId: string) => `/supplier/marketplace/rfq/${rfqId}/my-offer`,
    SUPPLIER_MARKETPLACE_RFQ_OFFER_DETAILS: (rfqId: string) => `/supplier/marketplace/rfq/${rfqId}/offer-details`,

    // Order endpoints
    ORDERS_CREATE: "/orders",
    ORDERS_CREATE_BY_TRANCHES: "/orders/create-by-tranches",
    ORDERS_MY_BUYER: "/orders/my-orders/buyer",
    ORDERS_MY_SUPPLIER: "/orders/my-orders/supplier",
    // Purchase Order header endpoints (include embedded tranches)
    ORDER_HEADERS_BUYER: "/orders/headers/buyer",
    ORDER_HEADERS_SUPPLIER: "/orders/headers/supplier",
    ORDER_HEADERS_MONITORING: "/orders/headers/monitoring",
    ORDER_HEADER_DETAILS: (headerId: string | number) => `/orders/headers/${headerId}`,
    ORDER_DETAILS: (orderId: string | number) => `/orders/${orderId}`,
    ORDER_GENERATE_AVIZ: (orderId: string | number) => `/orders/${orderId}/generate-aviz`,
    ORDER_GENERATE_CMR: (orderId: string | number) => `/orders/${orderId}/generate-cmr`,
    ORDER_CONFIRM: (orderId: string | number) => `/orders/${orderId}/confirm`,
    ORDER_ACCEPT: (orderId: string | number) => `/orders/${orderId}/accept`,
    ORDER_SHIP: (orderId: string | number) => `/orders/${orderId}/ship`,
    ORDER_COMPLETE: (orderId: string | number) => `/orders/${orderId}/complete`,
    ORDER_FINALIZE: (orderId: string | number) => `/orders/${orderId}/finalize`,
    ORDER_UPLOAD_DOCUMENT: (orderId: string | number) => `/orders/${orderId}/upload-document`,
    ORDER_VALIDATE_COMPLETE: (orderId: string | number) => `/orders/${orderId}/validate-complete`,
    ORDER_CONFIRM_DELIVERY: (orderId: string | number) => `/orders/${orderId}/confirm-delivery`,
    ORDER_AVIZ_DOWNLOAD_URL: (orderId: string | number) => `/orders/${orderId}/aviz/download-url`,
    ORDER_CMR_DOWNLOAD_URL: (orderId: string | number) => `/orders/${orderId}/cmr/download-url`,
    ORDER_CMR_SIGNED_DOWNLOAD_URL: (orderId: string | number) => `/orders/${orderId}/cmr-signed/download-url`,
    ORDER_HISTORY: (orderId: string | number) => `/orders/${orderId}/history`,
    ORDER_NOTES: (orderId: string | number) => `/orders/${orderId}/notes`,
    ORDER_NOTES_ATTACHMENTS: (orderId: string | number) => `/orders/${orderId}/notes/attachments`,
    ORDER_NOTES_UNREAD: (orderId: string | number) => `/orders/${orderId}/notes/unread-count`,
    ORDER_NOTES_READ_ALL: (orderId: string | number) => `/orders/${orderId}/notes/read-all`,
    ORDER_NOTE_DELETE: (orderId: string | number, noteId: string | number) => `/orders/${orderId}/notes/${noteId}`,
    ORDER_DOCUMENTS: (orderId: string | number) => `/orders/${orderId}/documents`,

    // Transport & Payment (Sprint 1)
    ORDER_TRANSPORT_DATA: (orderId: string | number) => `/orders/${orderId}/transport`,
    ORDER_UPLOAD_CMR_SIGNED: (orderId: string | number) => `/orders/${orderId}/upload-cmr-signed`,
    ORDER_UPLOAD_PAYMENT_DOCUMENT: (orderId: string | number) => `/orders/${orderId}/upload-payment-document`,
    ORDER_PAYMENT_VALIDATE: (orderId: string | number) => `/orders/${orderId}/payment-validate`,
    ORDER_PAYMENT_REJECT: (orderId: string | number) => `/orders/${orderId}/payment-reject`,
    ORDER_CMR_MARK_RECEIVED: (orderId: string | number) => `/orders/${orderId}/cmr-received`,

    ORDER_NOTE_PREVIEW_BY_OFFER: (offerId: string | number) => `/orders/order-note/offer/${offerId}/preview`,
    ORDER_NOTE_GENERATE_BY_OFFER: (offerId: string | number) => `/orders/order-note/offer/${offerId}/generate`,
    ORDER_NOTE_DOWNLOAD_URL_BY_OFFER: (offerId: string | number) => `/orders/order-note/offer/${offerId}/download-url`,
    ORDER_NOTE_PREVIEW_FOR_SUPPLIER: (offerId: string | number) => `/orders/order-note/offer/${offerId}/supplier/preview`,
    ORDER_NOTE_DOWNLOAD_URL_FOR_SUPPLIER: (offerId: string | number) => `/orders/order-note/offer/${offerId}/supplier/download-url`,
    ORDER_NOTE_PREVIEW_FOR_OPERATOR: (offerId: string | number) => `/orders/order-note/offer/${offerId}/operator/preview`,
    ORDER_NOTE_DOWNLOAD_URL_FOR_OPERATOR: (offerId: string | number) => `/orders/order-note/offer/${offerId}/operator/download-url`,

    // Rating endpoints
    ORDER_RATE: (orderId: string | number) => `/orders/${orderId}/rate`,
    ORDER_RATINGS: (orderId: string | number) => `/orders/${orderId}/ratings`,
    USER_RATINGS: (userId: string | number) => `/users/${userId}/ratings`,

    // Notification endpoints
    NOTIFICATIONS: "/notifications",
    NOTIFICATIONS_UNREAD_COUNT: "/notifications/unread-count",
    NOTIFICATIONS_STREAM: "/notifications/stream",
    NOTIFICATION_READ: (id: string | number) => `/notifications/${id}/read`,
    NOTIFICATIONS_READ_ALL: "/notifications/read-all",

    // Dashboard endpoints
    DASHBOARD_BUYER_STATS: "/dashboard/buyer/stats",
    DASHBOARD_SUPPLIER_STATS: "/dashboard/supplier/stats",
    DASHBOARD_OPERATOR_STATS: "/dashboard/operator/stats",
    DASHBOARD_BUYER_CALENDAR_EVENTS: "/dashboard/buyer/calendar-events",
    DASHBOARD_SUPPLIER_CALENDAR_EVENTS: "/dashboard/supplier/calendar-events",
    DASHBOARD_OPERATOR_CALENDAR_EVENTS: "/dashboard/operator/calendar-events",

    // Reports endpoints
    REPORTS_BUYER: "/reports/buyer",
    REPORTS_BUYER_CUSTOM: "/reports/buyer/custom",
    REPORTS_SUPPLIER: "/reports/supplier",
    REPORTS_SUPPLIER_CUSTOM: "/reports/supplier/custom",
    REPORTS_OPERATOR: "/reports/operator",
    REPORTS_OPERATOR_CUSTOM: "/reports/operator/custom",
    REPORTS_ADMIN: "/reports/admin",
    REPORTS_ADMIN_CUSTOM: "/reports/admin/custom",
}